<div
  class="notification slide-top"
  *ngIf="flashMessage"
  [ngClass]="flashMessage.className"
>
  <p class="is-size-6">{{ flashMessage.message }}</p>
</div>
